<template>
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left"></div>
    </div>
    <!-- 表格 -->
    <mytable
      ref="mytable"
      :maxHeight="300"
      :tableData="tableData_1"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
      :isselection="false"
    >
      <template #transportPlanShow="{ row }">
        <el-select
          v-model="row.transportPlan"
          @change="changeTransportPlan(row)"
          filterable
        >
          <el-option
            v-for="plan in transportPlans"
            :key="plan.planValue"
            :label="plan.planName"
            :value="plan.planValue"
          ></el-option>
        </el-select>
      </template>
      <template #remarks="{ row }">
        <el-input v-model="row.remarks"></el-input>
      </template>
    </mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew],
  components: {
    sorttable,
    paging,
    mytable,
    myDialog,
  },
  props: {
    dispatchId: {},
    isSee: {},
    type: {
      type: String,
      require: false,
      default: "edit",
    },
    op: {
      type: String,
      require: false,
      default: "edit",
    },
  },
  data() {
    return {
      pageGroupName: "admin_dispatch_detail_onway_dept_list", //  页面标识
      reportFiledsNumber: "admin_dispatch_detail_onway_dept_list", // 动态 条件、表头
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "WaybillEdit", //当前页面的方法
          param: 1, //自定义参数标记
        },
        // {
        //   name: "删除",
        //   methods: "delBtns",
        //   param: "",
        // },
        {
          name: "详情",
          methods: "detail",
          param: 2,
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        {
          name: "修改运单号",
          command: "updateNumber",
        },
        {
          name: "修改基本信息",
          command: "updateInfo",
        },
      ],
      //需要单独点击的列字段名数组
      fieldList: ["commandNumber"],
      Operatewidth: "220px", //操作列的列宽
      showFetchWaybill: false,
      waybills: [],
      tableData_1: [],
      showFetchOneWaybill: false,
      fetchOneWaybill: {
        waybillNumber: "",
      },
      transportPlans: [],
    };
  },
  computed: {
    editable() {
      return this.isSee != 1;
    },
    disabledSee() {
      return !this.editable;
    },
    feeCheckIn() {
      return this.op === "feeCheckIn";
    },
    baseEdit() {
      return this.op === "baseEdit";
    },
  },
  mounted() {
    this.getDetail();
  },
  watch: {
    dispatchId: {
      handler(val) {
        this.getDetail();
      },
    },
  },
  methods: {
    getDetail() {
      if (!this.dispatchId) {
        return;
      }
      this.getData({
        dispatchId: this.dispatchId,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.glo_btnList {
  margin-bottom: 10px;
}
</style> 